import { navLinkStyles } from ".";
import { NavLink } from "react-router-dom";
import type { NavLinkProps } from "react-router-dom";

export interface NavItemProps {
  href: NavLinkProps["to"];
  label: string;
  replace?: boolean;
}

export const NavItem = ({ label, href, replace }: NavItemProps) => (
  <li>
    <NavLink to={href} exact replace={replace} {...navLinkStyles}>
      {label}
    </NavLink>
  </li>
);
